import React, { useState } from "react";
import Image1 from "../../../Assets/Images/Gallery (1).jpg";
import Image2 from "../../../Assets/Images/Gallery (2).jpg";
import Image3 from "../../../Assets/Images/Gallery (3).jpg";
import Image4 from "../../../Assets/Images/Gallery (4).jpg";
import Image5 from "../../../Assets/Images/Gallery (5).jpg";

export default function Gallery() {
  // List of all images
  const allImages = [
    Image1,
    Image2,
    Image3,
    Image4,
    Image5,
    Image1,
    Image2,
    Image3,
    Image4,
    Image5,
  ];

  const [visibleImages, setVisibleImages] = useState(6);
  const [modalImageIndex, setModalImageIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Show more images
  const showMoreImages = () => {
    setVisibleImages(allImages.length);
  };

  // Open modal
  const openModal = (index) => {
    setModalImageIndex(index);
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Navigate modal images
  const modalPrev = () => {
    setModalImageIndex(
      (modalImageIndex - 1 + allImages.length) % allImages.length
    );
  };

  const modalNext = () => {
    setModalImageIndex((modalImageIndex + 1) % allImages.length);
  };

  return (
    <div className="gallery">
      <h2>Galerija</h2>
      <div className="gallery-grid">
        {allImages.slice(0, visibleImages).map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Gallery item ${index + 1}`}
            onClick={() => openModal(index)}
            className="gallery-image"
          />
        ))}
      </div>

      {visibleImages < allImages.length && (
        <button className="show-more-btn" onClick={showMoreImages}>
          Prikaži više
        </button>
      )}

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button onClick={closeModal} className="modal-close-button">
              <i className="fi fi-rr-cross-small"></i>
            </button>
            <img
              src={allImages[modalImageIndex]}
              alt={`Modal Slide ${modalImageIndex + 1}`}
              className="modal-image"
            />
            {/* Modal Arrows */}
            <button onClick={modalPrev} className="modal-arrow-left">
              <i className="fi fi-rr-arrow-small-left"></i>
            </button>
            <button onClick={modalNext} className="modal-arrow-right">
              <i className="fi fi-rr-arrow-small-right"></i>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
